<template>
  <section id="section__amount" class="view-container">
    <div class="width-100" v-if="me">
      <v-row no-gutters class="mt-10">
        <v-col cols="12">
          <p class="font--p-3">오늘부터 기다리지 말고<br />바로 당겨 받으세요!</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <img src="@/assets/images/apply/piggy_bank_coin.png" class="pig" />
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-5">
        <v-card class="card">
          <v-col cols="12">
            <v-card-text class="color--nice font-size--18 pb-0">미리 드리는 매출액*</v-card-text>
            <div v-if="!getOfferLoading && offer">
              <v-card-text class="font-size--14"> *{{ offer.baseDate }} 매출액 기준 </v-card-text>
              <v-card-text class="font--m-1 color--nice">
                {{ offer.amount | commaFormat }}원
              </v-card-text>
            </div>
            <div v-else>
              <v-col cols="12">
                <v-card-text class="sales_money">
                  <transition name="loader-transition">
                    <p>금액 산출 중...</p>
                  </transition>
                  <v-progress-circular indeterminate size="20" />
                </v-card-text>
              </v-col>
            </div>
          </v-col>
        </v-card>
      </v-row>

      <BasicButton v-ripple class="button next-button" :to="{ name: 'apply/complete' }"
        >내일부터 당겨 받기!</BasicButton
      >
    </div>
  </section>
</template>
<script>
import { sleep } from '@/util'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      offer: null,
      getOfferLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  async created() {
    this.getOffer()
  },
  methods: {
    ...mapActions('loan', ['getLoansOfferEarlyPayment']),
    async getOffer() {
      try {
        this.getOfferLoading = true
        this.offer = await this.getLoansOfferEarlyPayment()
        await sleep(1000)
      } finally {
        this.getOfferLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#section__amount {
  text-align: center;

  .pig {
    width: 100%;
    height: 210px;
    object-fit: contain;
  }

  .card {
    width: 100%;
    background-color: #e5f6ff;
  }

  .loader-transition-enter-active {
    transition: all 0.3s ease;
  }
  .loader-transition-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .loader-transition-enter, .loader-transition-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
}
</style>
